// Common menu items that can be reused
const songsMenu = {
  manuName: 'Songs',
  subMenu: [
    { name: 'Add Songs', iconName: 'add-songs', route: '/add-songs', allPaths: ['/add-songs'] },
    { name: 'Search Songs', iconName: 'search-songs', route: '/search-songs', allPaths: ['/search-songs'] },
  ],
};

const playlistsMenu = {
  manuName: 'Playlists',
  subMenu: [
    {
      name: 'Edit Playlists',
      iconName: 'edit-playlist',
      route: '/royalties/edit-playlist-main',
      allPaths: ['/royalties/edit-playlist-main', '/non-royalties/edit-playlist-main',
        '/royalties/edit-playlist-secondery', '/royalties/edit-playlist-and-server',
        '/non-royalties/edit-playlist-secondery', '/non-royalties/edit-playlist-and-server'],
    },
  ],
};

const customersMenu = {
  manuName: 'Customers',
  subMenu: [
    {
      name: 'All Customers',
      iconName: 'all-customers',
      route: '/customer-list',
      allPaths: ['/customer-list', '/customer-details', '/edit-customer-playlists', '/edit-customer-scheduler', '/update-customer'],
    },
    { name: 'New Customer', iconName: 'new-customer', route: '/new-customer', allPaths: ['/new-customer'] },
    { name: 'Groups', iconName: 'groups', route: '/groups', allPaths: ['/groups'] },
  ],
};

const editorCustomersMenu = {
  manuName: 'Customers',
  subMenu: [
    { name: 'All Customers', iconName: 'all-customers', route: '/customer-list', allPaths: ['/customer-list', '/customer-details', '/edit-customer-playlists', '/edit-customer-scheduler', '/update-customer'] },
  ],
};

const editorsMenu = {
  manuName: 'Editors',
  subMenu: [
    { name: 'All Editors', iconName: 'all-customers', route: '/editors', allPaths: ['/editors', '/update-editor'] },
    { name: 'New Editor', iconName: 'new-customer', route: '/new-editor', allPaths: ['/new-editor'] },
  ],
};

const tagsMenu = {
  manuName: 'Tags',
  subMenu: [
    {
      name: 'All Tags',
      iconName: 'all-tags',
      route: '/tags',
      allPaths: ['/tags'],
    },
  ],
};

// Role-specific sidebar configurations
export const sidebarData = {
  // Default/Admin sidebar (role 1)
  admin: {
    manuList: [
      songsMenu,
      playlistsMenu,
      customersMenu,
      editorsMenu,
      tagsMenu,
    ],
  },
  // Editor sidebar (role 3)
  editor: {
    manuList: [
      playlistsMenu,
      editorCustomersMenu,
    ],
  },
};
